"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _react2 = require("@emotion/react");
var _Button = _interopRequireDefault(require("../../../Button"));
var _utils = require("../../utils");
var _Text = _interopRequireDefault(require("../../../Text"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const NoticeAttachmentBlock = ({
  type = 'default',
  name,
  description,
  onDownload
}) => {
  const theme = (0, _react2.useTheme)();
  const canDownload = Boolean(onDownload);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Wrapper, {
    clickable: canDownload,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      nostyle: true,
      title: `Last ned ${type === 'cal' ? 'kalenderavtale' : 'fil'}`,
      onClick: () => onDownload && onDownload(),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.FileWrapperButton, {
        clickable: canDownload,
        borderRadius: theme.mypageBoxBorderRadius,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.IconBackground, {
          background: theme.illustrationPrimary10,
          children: (0, _utils.getFileIcon)(type)
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.FileInfoWrapper, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            wordBreak: "break-word",
            children: name
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            subtle: true,
            children: description
          })]
        })]
      })
    })
  });
};
var _default = exports.default = NoticeAttachmentBlock;